<template>
  <div>
    <div ref="header" class="top-k" :class="{' white-bg': (isBgWhite && !isPhoneSize) || $route.name != 'Home' , 'zindexTop': isPhoneSize }" :style="$route.name == 'Enterprise' ? 'width: 100%': '' ">
      <span id="head_span_goHome_iphone" class="logo-name iphone" @click="navtop_comm('logo');goHome();" v-if="isPhoneSize">
        <img src="@/assets/images/newlogo/logo.svg" alt="" style="width: 150px;"/>
      </span>
      <span id="head_span_goHome_logo-name" class="logo-name" @click="navtop_comm('logo'); goHome(); " v-else>
        <img src="@/assets/images/newlogo/whitelogo.svg" alt="" v-if="!isBgWhite && $route.name == 'Home'" style="width: 420px;"/>
        <img src="@/assets/images/newlogo/logo.svg" alt="" v-else style="width: 420px;" />
      </span>
      <div class="right-user" v-if="isPhoneSize">
        <i id="head_i_tel_app" class="iconfont icontel" data-agl-cvt="2" @click="tel();call_navtop();"></i>
        <i id="head_i_rightmenu_iconmenu" class="iconfont iconmenu" @click="rightmenu = true; navigatorTop('burger open');"></i>
      </div>
      <div class="menu" v-show="!(rightmenu && isPhoneSize)">
        <a id="head_a_menulink_active" href="https://www.byepest.com/" :class="{ active: activeIndex == 1}" @click.prevent="menulink('/');">品牌与服务</a>|
        <a id="head_a_menulink_1" href="javascript:;" :class="{ active: activeIndex == 5}" @click.prevent="menulink('/pest_wiki');">虫害百科</a>|
        <a id="head_a_menulink_2" href="javascript:;" @click.prevent="codeModalShow = true">虫虫社区</a>|
        <a id="head_a_menulink_3" href="javascript:;" @click="weixinLink()">个人中心</a>
      </div>
    </div>

    <div id="head_div_rightLogin_bggray-mask" class="bggray-mask" v-if="isPhoneSize && rightLogin" @click="rightLogin = false"></div>

    <el-drawer title="右侧菜单" :visible.sync="rightmenu" :direction="isPhoneSize ? 'ttb' : 'rtl'" :size="'100vh'" custom-class="rightmenu-k" :with-header="false">
      <div class="closeright">
        <img src="@/assets/images/newhome/close.svg" alt="" @click="rightmenu = false;navigatorTop('burger close');"/>
        <!-- <i id="head_i_rightmenu_iconclose" class="iconfont iconclose" @click="rightmenu = false;navigatorTop('burger close');"></i> -->
      </div>
        <ul class="menu-k">
          <li @click="linkhome()">
            品牌与服务
            <p>HOME & ABOUT</p>
          </li>
          <li @click="wikiLink()">
            虫害百科
            <p>PEST WIKIPEDIA</p>
          </li>
          <li @click="rightmenu = false;;codeModalShow = true">
            虫虫社区
            <p>BYEPEST COMMUNITY</p>
          </li>
          <li @click="weixinLink()">
            个人中心
            <p>MY SERVICES</p>
          </li>
        </ul>
    </el-drawer>

    <el-dialog title="立即咨询" :visible.sync="dialogVisible" class="contact-dialog-tip">
      <div class="title">立即咨询</div>
      <span class="contact-warn">小拜正在奋力敲代码中，点击下方热线电话，小拜将为您匹配专属顾问提供服务~</span>
      <div slot="footer">
        <a id="head_a_dialogVisible_cancle" href="javascript:;" class="cancle" @click="dialogVisible = false">取消</a>
        <a id="head_a_tel_btnfoot" href="tel:4001888282" @click.prevent="tel()" class="btnfoot"><i class="iconfont icontel1"></i>热线电话</a>
      </div>
    </el-dialog>
    <el-drawer v-if="isPhoneSize" :visible.sync="kefuShow" size="80%" :with-header="false" direction="btt">
      <iframe ref="myframe" :src="iframeUrl" frameborder="0" scrolling="auto" marginheight="0" marginwidth="0" width="100%" height="100%"></iframe>
    </el-drawer>
    <div class="right-bottom-tel" v-if="$route.name != 'CustomerCenterSet' && $route.name != 'ccbbC'">
      <i id="head_i_talk_icontel_p" class="iconfont icontel-p" @click="telxuan()"><span>电话</span></i>
      <i id="head_i_talk_icontel1" class="iconfont icontel1" @click="talk()"><span>客服</span></i>
      <!-- <i id="head_i_upTop_iconuppoint" class="iconfont iconuppoint" @click="upTop()">TOP</i> -->
    </div>

    <!-- pc 公众号弹窗 -->
    <!-- <el-dialog
      title="扫码下单"
      top="20vh"
      :visible.sync="weixinDialogImg"
      class="weixin-dialog-img">
      <div class="con">
        <img v-lazy="require('@/assets/images/pc/code/' + codeImg + '.jpg')" />
        <p>打开微信扫一扫 <br>进入小程序下单</p>
      </div>
    </el-dialog> -->

    <!-- 复制打开微信 -->
    <el-dialog
      title="打开微信搜索 拜耳虫虫拜拜 公众号"
      top="20vh"
      :visible.sync="weixinDialog"
      class="weixin-dialog-get">
      <div class="pw">
        <i class="iconfont iconweixin">微信搜一搜</i>
        <span><i class="iconfont iconsearch"></i>拜耳虫虫拜拜</span>
      </div>
      <p class="tips">关注公众号防走丢 轻松获取更多信息咨询</p>
      <a href="javascript:;" @click="copyAndOpen('拜耳虫虫拜拜')">复制并打开微信</a>
    </el-dialog>

    <div :class="codeModalShow ? 'code-modal show' : 'code-modal'" >
      <div class="close"><img src="@/assets/images/newhome/closew.svg" alt="" @click="codeModalShow = false" /></div>
      <div class="content">
        <h3>虫虫拜拜邀请您<br v-if="isPhoneSize">加入虫虫社区</h3>
        <div class="img"><img src="@/assets/images/newhome/codesq.png" alt="" />长按图片保存</div>
      </div>
    </div>
    <el-dialog
      title=""
      top="20vh"
      :visible.sync="weixinDialogImg"
      class="weixin-dialog-img">
      <div class="con" v-if="codeImgd == ''">
        <img v-lazy="require('@/assets/images/newhome/404.png')" style="width: 50%; height: auto;" />
        <p style="color: #4D4CC1;">服务即将上线，敬请期待</p>
      </div>
      <div class="con" v-else>
        <img v-lazy="require('@/assets/images/newhome/' + codeImgd + '.png')" />
        <p>请微信扫码查看相关详情</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { phone_register_for_business } from "@/api/api";
import Bus from "@/controller/bus";
import { setTimeout } from "timers";
export default {
  name: "Head",
  props: {
    msg: String,
    activeIndex: {
      type: Number,
      default: 0,
    },
    isPhoneSize: {
      type: Boolean,
      default: false,
    },
    headerMenuShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      codeImg: 'user',
      weixinDialogImg: false,
      rightmenu: false,
      topmenu: false,
      rightLogin: false,
      menuActiveIndex: '/',
      phone: "",
      code: "",
      issend: false,
      time: 0,
      loginloading: false,
      dialogVisible: false,
      whereSkip: 0,
      tipsCouponShow: true,
      navName: "",
      isBgWhite: false,
      productName: "",
      scrollTop: "",
      kefuShow: false,
      iframeUrl: "",
      weixinDialog: false,
      weixinDialogType: 'CustomerService',
      weixinDialogFrom: '',
      isSale: true,
      syLogin: false,
      syname: '',
      syphone: '',
      sycode: '',
      codeModalShow: false,
      weixinDialogImg: false,
      codeImgd: 'wx09'
    };
  },
  watch: {
    issend(data) {
      if (data == false) {
        this.loginloading = false;
      }
    },
    '$route': function(newV,oldV) {
      console.log("newV", newV);
    }
  },
  mounted() {
    let self = this;
    if (self.$rootUrl.indexOf("byepest.com") != -1) {
      self.iframeUrl =
        "https://customerservice.byepest.com/api/mobileweb/home?channel_id=26001&channel_key=26001sawb&wechatapp_id=209694&key=459538pt3&showMap=0";
    } else if (self.$rootUrl.indexOf("xpestuat.fview") != -1) {
      self.iframeUrl =
        "https://xpestuat-kf.fview.com/api/mobileweb/home?channel_id=26000&channel_key=26000302a&wechatapp_id=209694&key=45949io2a&showMap=0";
    } else {
      self.iframeUrl =
        "https://xpestsit-kf.fview.com/api/mobileweb/home?channel_id=11477&channel_key=11477xd8p&wechatapp_id=209694&key=39397cgjm&showMap=0";
    }
    if(this.$route.name == 'PestWiki' || this.$route.name == 'PestWikiDetail'){
      this.activeIndex = 5
    }

    self.$on("tiggle", function (value) {
      // service里的结算入口,toBPrice是toB结算,couponLink 优惠券领取
      self.whereSkip = value;
      self.rightLogin = true;
    });
    self.$on("contactUs", function (data) {
      self.navName = data;
      self.dialogVisible = true;
    });
    self.$on("productName", function (data) {
      self.productName = data;
    });

    self.$on("weixinDialog", function (data) {
      self.weixinDialogType = data
      self.weixinDialog = true;
      self.weixinDialogFrom = data
    });

    self.$on("sylogin", function (value) {
      // 商业除虫登录
      self.syLogin = true;
    });

    self.Pageview();
    // self.timeSetHidden()
    window.addEventListener("scroll", self.handleScroll, true);
    window.addEventListener("scroll", self.scrollToTop);

    self.$nextTick(function () {
      this.gaHandleScroll();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    linkwxShow(name) {
      this.codeImgd = name
      this.weixinDialogImg = true
    },
    linkhome() {
      this.$router.push({ path: "/" });
      this.rightmenu = false;
    },
    weixinLink() {
      // window.location.href="weixin://";
      this.linkwxShow('wx09')
    },
    isSaleChoose(){
      this.isSale = !this.isSale
    },
    copyAndOpen(data){
      let url = data;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message.success('复制成功,即将打开微信!');
      oInput.remove()
      if(this.weixinDialogType == 'MyPage') {
        this.$ga.ga_comm('MyPage','MyPage','wechat_copy','Tools')
      }else{
        this.$ga.wechat_copy(this.weixinDialogFrom)
      }
      window.location.href="weixin://";
    },
    telxuan() {
      this.$ga.ga_comm('CustomerService','CustomerService','call_float','Tools')
      window.location.href = "tel:4001888282";
    },
    talk() {
      if (this.isPhoneSize) {
        this.kefuShow = true;
      } else {
        // window.location.href = "tel:4001888282";
        ZM.close();
        ZM.open();
      }
      this.$ga.serviceHotline(this.getPathName(), "Livechat");
    },
    upTop() {
      const self = this;
      self.$ga.topNavClick("back to top");
      console.log(this.$route.name);

      if (self.$route.name == "Home" && !self.isPhoneSize) {
        Bus.$emit("homeTop", true);
        return;
      }

      if (self.$route.name == "Enterprise") {
        Bus.$emit("enterpriseTop", true);
        return;
      }

      let timer = setInterval(() => {
        let ispeed = Math.floor(-self.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          self.scrollTop + ispeed;
        if (self.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于120显示回顶部图标，小于120则隐藏
    scrollToTop() {
      const self = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      self.scrollTop = scrollTop;
      if (self.scrollTop > 120) {
        // self.flag = true;
      } else {
        // self.flag = false;
      }
    },
    gaHandleScroll() {
      let self = this;
      console.log("sccc");
      let delayer = setTimeout(function () {
        console.log("sccc222");
        let totalH = 0;
        let _urlType = "byepest";
        let _path = self.$route.path;
        if (self.$route.name == "Home") {
          totalH = document.getElementsByClassName(".new-home")[0].scrollHeight;
          _urlType = "home";
          _path = "/home";
        } else if (self.$route.name == "Enterprise") {
          totalH = document.getElementsByClassName(".new-home")[0].scrollHeight;
          _urlType = "home";
        } else {
          totalH = document.getElementsByClassName("byepest")[0].scrollHeight;
        }

        let clientH = window.innerHeight || document.documentElement.clientHeight;
        self.$ga.gaHandleScroll(totalH, clientH, _urlType, _path);
        clearTimeout(delayer);
      }, 1500);
    },
    handleScroll() {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop ||
        (document.getElementsByClassName("home").length > 0 ? document.getElementsByClassName("home")[0].scrollTop : 0) ||
        (document.getElementsByClassName("byepest").length > 0 ? document.getElementsByClassName("byepest")[0].scrollTop : 0);
      if (scrollTop > 50) {
        this.isBgWhite = true;
      } else {
        this.isBgWhite = false;
      }
    },
    topNavClick() {
      let self = this;
      self.$ga.topNavClick("icon");
    },
    timeSetHidden() {
      setTimeout(() => {
        this.tipsCouponShow = false;
      }, 6000);
    },
    wikiLink() {
      this.$router.push({ name: "PestWiki" });
      this.rightmenu = false;
      this.topmenu = false;
    },
    tel() {
      let self = this;
      window.location.href = "tel:4001888282";
      self.$ga.custom_service_hotline(self.navName);
    },
    custom_service_hotline() {},
    toBLink() {
      this.$router.push({ name: "Enterprise" });
    },
    userlink(type) {
      let self = this;
      if (this.$route.path.indexOf("enterprise") == -1 && !this.isPhoneSize) {  //除了商业除虫，pc端toc的用户中心弹窗显示扫码微信小程序
        this.weixinDialogImg = true
        if(type != 'head') {
          this.codeImg = this.$route.path.split('/service/')[1] == 'baiyikancha' || this.$route.path.split('/service/')[1] == 'baiyiyufang' ? 'white_ant_stand' : this.$route.path.split('/service/')[1]
          if(!this.codeImg) {
            this.codeImg = 'pest_management'
          }
        }else{
          this.codeImg = 'user'
        }
        return
      }

      if (window.localStorage.getItem("isLogin") == "true") {
        //已登录
        if (this.$route.path.indexOf("enterprise") == -1) {
          this.$router.push({ name: "User" });
          // window.location.href = self.$rootUrl + '/mobile/?selected=me'
        } else {
          if (this.isPhoneSize) {
            this.$router.push({ name: "CustomerCenterSet" });
          } else {
            this.$router.push({ name: "Order" });
          }
        }
      } else {
        //未登录
        this.$ga.Pageview("", "/login");
        this.rightLogin = true;
      }
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    linkRouter(name) {
      this.$router.push({ path: name });
      this.rightmenu = false;
      this.topmenu = false;
    },
    menulink(number) {
      // this.menuActiveIndex = number;
      this.$router.push({ path: number });
      this.rightmenu = false;
      this.topmenu = false;
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = "短信已发送";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.issend = false;
      }
    },

    sysumbitIn() {
      let self = this;
      let params = {
        name: self.syname,
        phone: self.syphone,
        code: self.sycode,
        registry_platform: 1,
      };
      let reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (self.syphone == "") {
        self.$message.error("请输入手机号码");
        return false;
      }
      if (!reg.test(self.syphone)) {
        self.$message.error("手机格式不正确");
        return false;
      }
      if (self.sycode == "") {
        self.$message.error("请输入验证码");
        return false;
      }

      phone_register_for_business(params).then((res) => {
        if (res.err == 0) {
          self.$message.success('提交成功');
          self.syLogin = false
        } else if(res.err == 3014) {
          self.$message.error('验证码错误');
        } else {
          self.$message.error(res.msg);
        }
      });
    },
    Pageview(productName) {
      let self = this;
      let storage = window.sessionStorage;
      storage.setItem("productName", productName);
    },
    inputClick(name) {
      let self = this;
      if (name == "phone") {
        self.$ga.phoneClick();
      } else {
        self.$ga.codeClick();
      }
    },
    navigatorTop(name) {
      let self = this;
      self.$ga.navigatorTop(name);
    },
    navigatorBurger(name) {
      let self = this;
      self.navName = name;
      self.$ga.navigatorBurger(name);
    },
    getPathName(){
      console.log("this.$route.path", this.$route.path);
      let url = this.$route.path;

      let _arr = [
        {
          name: '蟑螂拜拜',
          nameEn: 'zhanglang',
        },
        {
          name: '跳蚤拜拜',
          nameEn: 'tiaozao',
        },
        {
          name: '蚂蚁拜拜',
          nameEn: 'mayi',
        },
        {
          name: '老鼠拜拜',
          nameEn: 'laoshu',
        },
        {
          name: '专业上门检测',
          nameEn: 'profession',
        },
        {
          name: '综合虫害预防',
          nameEn: 'prevention',
        },
        {
          name: '白蚁预防',
          nameEn: 'baiyiyufang',
        },
        {
          name: '白蚁灭治',
          nameEn: 'baiyikancha',
        },
        {
          name: '尊享版包年套餐',
          nameEn: 'bieshu',
        },
        {
          name: '蚊虫拜拜',
          nameEn: 'feichong',
        },
        {
          name: '常见虫害',
          nameEn: 'commonpest',
        },
        {
          name: '白蚁专区',
          nameEn: 'termite',
        },
        {
          name: '别墅除虫',
          nameEn: 'villapest',
        },
        {
          name: '商业除虫',
          nameEn: 'enterprise',
        },
        {
          name: '品牌故事',
          nameEn: 'about',
        },
        {
          name: '用户评价',
          nameEn: 'evaluate',
        },
        {
          name: '虫害百科',
          nameEn: 'pest_wiki',
        },
        {
          name: 'lead',
          nameEn: 'ccbbA',
        }
      ]
      let _name = '首页'

      _arr.forEach(function(item,index){
        if(url.indexOf(item.nameEn) != -1) {
          _name = item.name
          return
        }
      });

      return _name
    },
    call_navtop() {
      this.$ga.call_navtop(this.getPathName());
    },
    navtop_comm(type) {
      this.$ga.nav_top_comm(type,this.getPathName());
    },
    closeTips() {
      this.tipsCouponShow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

/deep/ .el-dialog__wrapper.syLogin {
  .el-dialog {
    max-width: 360px !important;
    width: 360px;
    border-radius: 5px;
    text-align: left;
    box-shadow: none;

    .el-dialog__header {
      background-color: #00B8EE;
      border-radius: 5px 5px 0 0;
      padding: 38px 0 24px 32px;
      color: #fff;
      .dialog-title {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 2px;
      }
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    .el-dialog__body {
      padding: 0 32px 40px 32px;

      .login-k {
        font-size: 14px;
        line-height: 22px;

        .inputdiv {
          position: relative;
        }

        .btns {
          position: absolute;
          right: 0;
          background-color: rgba(255, 255, 255, .4);
          color: #00B8EE;
          line-height: 45px;
          bottom: 0;

          .yz {
            color: #969696;
          }
        }

        input {
          width: 100%;
          height: 45px;
          border-bottom: 1px solid #E0E0E0;
        }

        .login-reg-btn {
          background-color: #00B8EE;
          border-radius: 5px;
          line-height: 36px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          width: 100%;
          margin-top: 26px;
          margin-bottom: 6px;
        }

        .agree-tip {
          font-size: 11px;
          a {
            color: #00B8EE;
          }
        }

        h3 {
          font-size: 16px;
          color: #828282;
          font-weight: 500;
          margin: 0;
          padding-top: 26px;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue